module.exports = __webpack_public_path__ + "static/media/note-1.3ea3ee01.jpg";